/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * UtilService contains all utility functions
 *
 * @module enervee_utils.common
 */

UtilService.$inject = [
    '$location',
    '$anchorScroll',
    '$filter',
    'SETTINGS',
    'SITESETTINGS',
    'CATEGORYSETTINGS',
    '$rootScope',
    '$state',
    '$timeout',
    '$uibModal',
    '$window',
    '$log',
];

function UtilService(
    $location,
    $anchorScroll,
    $filter,
    SETTINGS,
    SITESETTINGS,
    CATEGORYSETTINGS,
    $rootScope,
    $state,
    $timeout,
    $uibModal,
    $window,
    $log
) {
    var _pub = {};

    /**
     * Returns the values of a list if the list is not empty.
     * Returns `null` for and empty list.
     *
     * @param valuesList list of values
     * @returns {null} list values or `null`
     */
    _pub.getListValuesOrNull = function (valuesList) {
        return valuesList.length > 0 ? valuesList : null;
    };

    /**
     * converts the querystring in the url into json type object.
     * @param queryString
     * @returns {{}}
     */
    _pub.queryStringToDict = function (queryString) {
        if (queryString.length === 0) {
            return {};
        }
        if (queryString[0] === '?') {
            queryString = queryString.substr(1);
        }
        var paramStrings = queryString.split('&');
        var dict = {};
        paramStrings.forEach(function (paramString) {
            var keyValuePair = paramString.split('=');
            var key = decodeURIComponent(keyValuePair[0]).toLowerCase().replace(/_/g, '-');
            var value = decodeURIComponent(keyValuePair[1]);
            if (value.indexOf('&') > -1 || value.indexOf('=') > -1) {
                value = _pub.queryStringToDict(value);
            }
            if (key in dict) {
                dict[key] = _pub.forceArray(dict[key]);
                dict[key].push(value);
            } else {
                dict[key] = value;
            }
        });
        return dict;
    };

    /**
     * Determines whether or not the feature is enabled for the current site
     *
     * @param feature
     * @return boolean
     */
    _pub.isFeatureEnabled = function (feature) {
        return _pub.getSiteSetting('enabled_features', []).indexOf(feature) !== -1;
    };

    /**
     * Returns an offers affiliate link for the current site or the offer link.
     * @param {{site_affiliate_links_map:object, link:string}} offer - single offer object
     * @returns {*}
     */
    _pub.getAffiliateLink = function (offer) {

        var offerLink = offer.link;
        if (offer.site_affiliate_links_map) {
            var siteId = _pub.getSetting('siteId');
            offerLink = siteId in offer.site_affiliate_links_map ?
                offer.site_affiliate_links_map[siteId] :  offer.link;

        }

        return offerLink;

    };

    /**
     * Tries to get a category setting. If the setting doesn't exist for the given category, it tries
     * to get the setting for the entire site. Returns the setting_default if neither exist.
     * @param category - the id of the category to get the setting for
     * @param setting_key - the setting key that we want
     * @param setting_default (optional) - if passed and the settings are not defined, this will be returned
     * @returns {*}
     */
    _pub.getCategoryOrSiteSetting = function(category, setting_key, setting_default) {
        setting_default = setting_default || null;
        let setting_value = _pub.getCategorySetting(category, setting_key, setting_default);
        if (setting_value === setting_default) {
            setting_value = _pub.getSiteSetting(setting_key, setting_default);
        }
        return setting_value;
    };

    /**
     * Returns a category setting's value. Returns null or the setting_default if the setting
     * doesn't exist or the category has no settings specified.
     * @param category - the id of the category to get the setting for
     * @param setting_key - the setting key that we want
     * @param setting_default (optional) - if passed and the setting is not defined, this will be returned
     * @returns {*}
     */
    _pub.getCategorySetting = function(category, setting_key, setting_default) {
        setting_default = setting_default || null;
        if (!(category in CATEGORYSETTINGS)) {
            return setting_default;
        } else if (setting_key in CATEGORYSETTINGS[category]) {
            return CATEGORYSETTINGS[category][setting_key];
        }
        return setting_default;
    };

    /**
     * Returns a site setting's value. Returns null or the setting_default if the setting doesn't exist.
     * @param setting - the name of the site setting
     * @param setting_default (optional) - if passed and the setting is not defined, this default will be returned
     * @returns {*}
     */
    _pub.getSiteSetting = function (setting, setting_default) {
        if (setting in SITESETTINGS) {
            return SITESETTINGS[setting];
        }
        $log.warn('Site Setting ' + setting + ' does not exist.');

        if (setting_default === undefined) {
            setting_default = null;
        }
        return setting_default;
    };

    /**
     * Returns a setting's value. Returns null or the setting_default if the setting doesn't exist.
     * @param setting - the name of the setting
     * @param setting_default (optional) - if passed and the setting is not defined, this default will be returned
     * @returns {*}
     */
    _pub.getSetting = function (setting, setting_default) {
        setting_default = setting_default || null;
        if (setting in SETTINGS) {
            return SETTINGS[setting];
        }
        $log.warn('Setting ' + setting + ' does not exist.');
        return setting_default;
    };

    /**
     * Scrolls to the section
     *
     * @param section
     */
    _pub.goToSection = function (section) {
        var originalLocation = $location.hash();
        $location.hash(section);
        $anchorScroll();
        $location.hash(originalLocation);
    };

    /**
     * Adds a canonical url to the head of the html of thh page
     *
     * @param $location
     */
    _pub.addCanonicalUrl = function ($location) {

        var CANONICAL_DOMAIN_NAME = _pub.getSiteSetting('canonical_url_domain');

        var oldCanonicalElement = angular.element(document.querySelector('link[rel="canonical"]'));
        oldCanonicalElement.remove();

        var canonicalUrl = CANONICAL_DOMAIN_NAME + $location.url();
        var link = angular.element('<link>');
        link.attr('rel', 'canonical');
        link.attr('href', canonicalUrl);

        angular.element('head').append(link);

    };

    /**
     * Helper function to check if the state is a category page.
     *
     * @param {String} stateName - The name of the state to check.
     * @returns {Boolean}
     */
    _pub.stateIsCategory = function(stateName) {
        var categoryPages = ["results"];
        return categoryPages.indexOf(stateName) > -1;
    };

    /**
     * Helper function to check if the state is a product page.
     *
     * @param {String} stateName - The name of the state to check.
     * @returns {Boolean}
     */
    _pub.stateIsProduct = function(stateName) {
        var productPages = ["product", "product.base", "product.simplified"];
        return productPages.indexOf(stateName) > -1;
    };

    /**
     * Retrieves the name of the current view for the Tag Manager
     */
     _pub.getPageType = function () {
         if ($state.current.data) {
             return $state.current.data.pageType || 'other';
         }
         return 'other';
     };


    /**
     * From the bootstrap element tags, we determine the screen size
     * of either xs, sm, md, or lg.
     * @returns {string}
     */
    _pub.getScreenSize = function() {
        var current_screen_size = '';
        $('#screen-size-trigger div').each(function () {
            if ($(this).css('display') == 'block') {
                current_screen_size = $(this).data('screen-size');
            }
        });
        return current_screen_size;
    };


    /**
     * Returns true if screen size is xs or sm.
     * Used to determine if we are serving the mobile
     * experience of the site.
     * @returns {boolean}
     */
    _pub.isMobile = function() {
        var screenSize = _pub.getScreenSize();
        return screenSize === 'xs' || screenSize === 'sm';
    };


    var debouncedFunctions = {};
    /**
     * Debounces the `func` to wait until the number of milliseconds
     * defined by `wait` have passed before calling function.
     */

    _pub.debounce = function(key, func, wait) {
        wait = wait || 500;
        if (debouncedFunctions[key]) {
            $timeout.cancel(debouncedFunctions[key]);
        }
        debouncedFunctions[key] = $timeout(func, wait);
    };

    /**
     * Checks site setting for custom redirect based on key provided.
     * If redirect doesn't exist, redirect to index.
     * @param key
     * @returns {*}
     */
    _pub.getCustomRedirect = function(key) {
        var redirects = _pub.getSiteSetting('redirects');
        if (key in redirects) {
            return redirects[key];
        } else {
            return 'index';
        }
    };

    _pub.getKeyByValue = function(dict, value) {
        var keyName = null;
        Object.keys(dict).forEach(function (key) {
            if (dict[key] === value){
                keyName = key;
            }
        });
        return keyName;
    };

    _pub.queryParamsToDictList = function(queryParams) {
        var currentParams = queryParams.split('&');
        var list = [];
        currentParams.forEach(function(param){
            var keyValuePair = param.split('=');
            var tempDict = {};
            tempDict[keyValuePair[0]] = keyValuePair[1];
            list.push(tempDict);
        });
        return list;
    };

    _pub.queryParamsToDict = function(queryParams) {
        var currentParams = queryParams.split('&');
        var paramObj = {};
        currentParams.forEach(function(param){
            var keyValuePair = param.split('=');
            var key = decodeURIComponent(keyValuePair[0]).toLowerCase().replace(/_/g, '-');
            var value = decodeURIComponent(keyValuePair[1]);

            if (key !== 'query') {
                // unless this is a query, we want to make this match the url value saved for the facet.
                value = value.toLowerCase().replace(/ /g, '-');
            }
            if (key in paramObj) {
                paramObj[key].push(value);
            } else {
                paramObj[key] = [value];
            }
        });
        return paramObj;
    };

    /**
     * Generates a random string
     *
     * @param length (length of the generated string)
     * @returns {string}
     */
    _pub.generateString = function (length) {
        var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
        var string = "";
        for (var x = 0; x < length; x++) {
            var i = Math.floor(Math.random() * chars.length);
            string += chars.charAt(i);
        }

        return string;
    };


    /**
     * Helper function to see if a url parameter has been passed in the url.
     * @param param
     */
    _pub.hasUrlParam = function(param) {
        var urlParams = $location.search();
        return (param in urlParams);
    };

    /**
     * Function to check if a feature should be
     * enabled/disabled based on url params. e.g.
     *
     * `?benefits_modal=true&editorial_modal=false`
     *
     * @param param
     */
    _pub.isFeatureUrlParamEnabled = function(param) {
        var isFeatureEnabled = null;
        var urlParams = $location.search();

        if (param in urlParams) {
            isFeatureEnabled = (urlParams[param].toLowerCase() === 'true');
        }
        return isFeatureEnabled;
    };

    /**
     * Opens the given link in a new window.
     * @param link
     */
    _pub.openLinkNewWindow = function (link) {
        if (link) {
            $window.open(link, '_blank');
        }
    };

    /**
     * Helper function to open a generic modal with multiple action
     * buttons.
     *
     * @param {Object} config A hash of configuration settings
     * @param {String} [size="sm"]
     * @param {String} config.title The title text for the modal, may contain HTML
     * @param {String} config.body The body text for the modal, may contain HTML
     * @param {Object[]} config.buttons An array of config objects for the buttons
     * to be displayed in the modal
     * @param {String} config.buttons[].text The text for the button
     * @param {Function} config.buttons[].action The action to happen when the
     * button is clicked. The method is passed the `dismiss` function for the
     * modal, so that the modal may be closed.
     * @param {String} [config.buttons[].class="btn-accent"] The CSS class for
     * the button (can be multiple, space-separated classes).
     */
    _pub.openGenericModal = function(config) {
        var defaults = {
            appendTo: angular.element('div[ui-view]'),
            ariaLabelledBy: $filter('stripTags')(config.title),
            ariaDescribedBy: $filter('stripTags')(config.body),
        };
        var staticConfig = {
            controller: 'GenericModalCtrl',
            controllerAs: 'vm',
            templateUrl: '/app/shared/modals/genericModal/genericModalView.html',
            resolve: {
                config: function() {
                    return config;
                }
            }
        };
        $uibModal.open(Object.assign(defaults, config, staticConfig));
    };

    /**
     * Opens a an "alert" modal, which has no actions, just a single button that closes the
     * the modal.
     * @param {Object} config A hash of configuration settings (see openGenericModal)
     * @param {String} [config.buttonText="OK"] the text for the single button on the modal.
     */
    _pub.openAlertModal = function(config) {
        var defaults = {
            buttons: [
                {
                    text: config.buttonText || 'OK',
                    action: function(dismiss) {
                        dismiss('success');
                    },
                    class: 'btn-wide'
                }
            ]
        };
        _pub.openGenericModal(Object.assign(defaults, config));
    };

    /**
     * formats url path with variables from context if available and present in the path.
     * @param path
     * @param context
     * @returns {{path: *, context: *}}
     *
     * @example
     *  contextedUrl = UtilService.addContextToUrl("application/{application_id}", {'application_id': 12});
     *  var contextWithoutUrlParameters = contextedUrl.context;
     *  var pathWithParameters = contextedUrl.path;
     */
    _pub.addContextToUrl = function(path, context) {
        Object.keys(context).forEach(function(key){
            if (path.indexOf('{' + key + '}') > -1){
                path = path.replace('{' + key + '}', context[key]);
                delete context[key];
            }
        });
        return {path: path, context: context};
    };

    /**
     * Takes an element and index number and changes the element's z-index.
     * @param element - html element we want to change. ie #autocomplete or .category-selector
     * @param index - number to change z-index to
     */
    _pub.setZIndex = function (element, index) {
        var chosenElement = angular.element(document.querySelector(element));
        chosenElement.css('z-index', index);
    };

    /**
     * Take object of query params and create query param string.
     * Keys are the param key and values are the param values.
     *
     * @param {Object} params
     * @return {string} Query params formatted for use in url.
     */
    _pub.formatQueryParams = function(params) {
        let paramStr = '';
        for (let param in params) {
            paramStr += `${param}=${params[param]}&`;
        }
        return paramStr;
    }

    /**
     * Helper function to add params to a given URL. Checks if query params exist already or not.
     * @param url
     * @param param
     * @returns {string}
     */
    _pub.addQueryParamToURL = function (url, param) {
        var tempURL = url;
        var isQuestionMarkPresent = tempURL && tempURL.indexOf('?') !== -1;
        var separator = isQuestionMarkPresent ? '&' : '?';
        return tempURL + separator + param;
    };

    /**
     * Makes sure the value is an array. If it's not, the value wrapper in an array is
     * returned.
     *
     * @param {*} val
     * @return {Array}
     */
    _pub.forceArray = function (val) {
        val = val || [];
        if (!Array.isArray(val)) {
            return [val];
        }
        return val;
    };

    /**
     * Checks if the object passed is an iterable object (array or object).
     *
     * @param {*} obj
     * @return {Boolean}
     */
    _pub.isIterable = function (obj) {
        return angular.isArray(obj) || angular.isObject(obj);
    };

    /**
     * For each _value_ in the potentially deeply nested object, perform the callback.
     * The callbacks two arguments are the item and its key/index.
     * If the object passed is not iterable, simply exits without calling the callback.
     *
     * @param {Array|Object} obj An iterable object
     * @param {Fucntion} callback Callback to be run with every value in the `obj`.
     */
    _pub.forEachDeep = function (obj, callback) {
        var nestedCallback = function (item, key) {
            if (_pub.isIterable(item)) {
                angular.forEach(item, nestedCallback);
            } else {
                callback.call(undefined, item, key);
            }
        };

        if (_pub.isIterable(obj)) {
            angular.forEach(obj, nestedCallback);
        }
    };

    /**
     * No matter the value passed, returns an flattened array of values.
     * NOTE: If any of the values (top-level or nested) are objects, keys are not preserved.
     *
     * @param {*} val
     * @return {Array<*>} A flat array of values
     */
    _pub.flattenDeep = function (val) {
        var output = [];
        if (_pub.isIterable(val)) {
            _pub.forEachDeep(val, function (nestedVal) {
                output.push(nestedVal);
            });
        } else {
            output.push(val);
        }
        return output;
    };

    /**
     * Given an array of objects, returns a map object of them by a specified prop
     *
     * @param {Array<Object>} objects
     * @param {String} prop a property that has a unique value on each object in the
     * list (e.g. "id")
     * @param {Function} [returnFunction] Takes the object being iterated over and
     * returns the value to be stored in the hash
     * @return {Object}
     */
    _pub.mapByProperty = function (objects, prop, returnFunction) {
        returnFunction = returnFunction || function returnFunction(obj) {
            return obj;
        };
        return objects.reduce(function (hash, object) {
            hash[object[prop]] = returnFunction(object);
            return hash;
        }, {});
    };

    /**
     * Given an array of objects, returns a map object of them _grouped_ by a specified
     * prop
     *
     * @param {Array<Object>} objects
     * @param {String} prop a property that exists on each object in the list
     * (e.g. "category_id")
     * @param {Function} [returnFunction] Takes the object being iterated over and
     * returns the value to be stored in the hash
     * @return {Object}
     */
    _pub.groupByProperty = function (objects, prop, returnFunction) {
        returnFunction = returnFunction || function returnFunction(obj) {
            return obj;
        };
        return objects.reduce(function (hash, object) {
            hash[object[prop]] = hash[object[prop]] || [];
            hash[object[prop]].push(returnFunction(object));
            return hash;
        }, {});
    };

    /**
     * Takes an array of objects to chunk into smaller arrays.
     *
     * @param {Array} arr - Array of items to chunk
     * @param {Number} chunkLength - Number of items per chunk. Defaults to 30
     * @returns {Array}
     */
    _pub.chunkArray = function (arr, chunkLength) {
        arr = _pub.forceArray(arr).slice(0);
        chunkLength = chunkLength || 30;
        var chunks = [];
        while (arr.length > 0) {
            chunks.push(arr.splice(0, chunkLength));
        }
        return chunks;
    };

    /**
     * Takes an array of objects and a property name. Iterates over all objects in the array and creates a
     * new array of just the property values if the property exists on the object.
     *
     * @param {Array} arr - Array of objects to pull properties from
     * @param {String} propName - Name of the property to pull from the objects
     * @returns {Array}
     */
    _pub.reduceToProperty = function (arr, propName) {
        arr = _pub.forceArray(arr);
        return arr.map(function (obj) {
            if (angular.isObject(obj) && obj.hasOwnProperty(propName)) {
                return obj[propName];
            }
        }).filter(function (element) {
            return typeof element !== 'undefined';
        });
    };

    /**
     * Returns a new object with the same values, but with the keys replaced.
     * The replace function takes the key being replaced, as well as the original object.
     *
     * @param {Object} obj
     * @param {Function} replaceFunction
     * @return {Object}
     */
    _pub.replaceKeys = function(obj, replaceFunction) {
        if (!replaceFunction) {
            throw Error('UtilService.replaceKeys requires a replace function');
        }
        var newObj = {};
        angular.forEach(obj, function (value, key) {
            var newKey = replaceFunction(key, obj);
            newObj[newKey] = value;
        });
        return newObj;
    };

    /**
     * Returns a filtered array of the first array, based on whether each item is
     * also included in the second array.
     *
     * @param {Array} arr1 the array to filter
     * @param {Array} arr2
     * @return {Array}
     */
    _pub.filterIncluded = function (arr1, arr2) {
        return arr1.filter(function (item) {
            return arr2.indexOf(item) > -1;
        });
    };

    /**
     * Returns a filtered array of the first array, based on whether each item is
     * _not_ included in the second array.
     *
     * @param {Array} arr1 the array to filter
     * @param {Array} arr2
     * @return {Array}
     */
    _pub.filterExcluded = function (arr1, arr2) {
        return arr1.filter(function (item) {
            return arr2.indexOf(item) === -1;
        });
    };

    /**
     * Rounds a number to the specified number of decimal places.
     * NOTE: while the math here doesn't really appear to be neccessary,
     * this is to help address issues in JS with floating-point precision.
     *
     * @example
     * var rate = 75.6 / 100  // this _should_ be 0.756, but is 0.7559999999999
     * rate = UtilService.roundToFixed(rate, 3); // Is actually 0.756
     *
     *
     * @param {number} number
     * @param {integer} decimalPlaces
     * @return {number}
     */
    _pub.roundToFixed = function (number, decimalPlaces) {
        decimalPlaces = decimalPlaces || 0;
        var powerOfTen = Math.pow(10, decimalPlaces);
        return Math.round(number * powerOfTen) / powerOfTen;
    };

    /**
     * Pad a number with the given fill if it's not the required number
     * of integers.
     *
     * @param {integer} number
     * @param {integer} width
     * @param {string} fill
     * @return {string}
     */
    _pub.pad = function (number, width, fill) {
        number = number + '';
        fill = fill || '0';
        return number.length >= width ?
            number :
            new Array(width - number.length + 1).join(fill) + number;
    };

    /**
     * Retrieve an array of the values of an object, similar to Object.values()
     *
     * @param {Object} obj
     * @return {Array}
     */
    _pub.objectValues = function (obj) {
        return Object.keys(obj).map(key => obj[key]);
    };

    /**
     * Retrieve an array of the key and value pairs of an object, similar to
     * Object.entries()
     *
     * @param {Object} obj
     * @return {Array}
     */
    _pub.objectEntries = function (obj) {
        return Object.keys(obj).map(key => [key, obj[key]]);
    };

    /**
     * Focuses the passed element. If the argument passed is a jQuery selector, then
     * actual existence of a node is checked before focusing.
     *
     * @param {Node|Object} elem
     */
    _pub.focusElement = function (elem) {
        if (!elem) {
            return false;
        }
        if (elem.nodeName) {
            elem.focus();
        } else if (elem.length && elem[0].nodeName) {
            elem[0].focus();
        }
    };

    /**
     * Gets an icon class from the icon mapping site setting.
     *
     * @param iconName
     * @param defaultIconClass
     * @returns {*}
     */
    _pub.getIconClass = function (iconName, defaultIconClass) {
        defaultIconClass = defaultIconClass || null;
        var iconDictionary = _pub.getSiteSetting('icon_mapping', {});
        if (iconDictionary.hasOwnProperty(iconName)) {
            return iconDictionary[iconName];
        }
        return defaultIconClass;
    };

    /**
     * Extends the first argument with the properties of the second (and following) arguments.
     * If the first argument is _not_ an object, nothing happens.
     *
     * @param {Object} obj
     * @param {Array<Obj>} otherObjs
     */
    _pub.extendObj = function (obj, ...otherObjs) {
        if (!angular.isObject(obj)) return;
        angular.extend(obj, ...otherObjs);
    };

    /**
     * Converts a string into an integer value that should be unique for that
     * string.
     *
     * Given any string, the hash value for that string should be consistent
     * no matter how many times it's run, and for any two strings the
     * following should always hold:
     *   * string1 == string2 -> hashString(string1) == hashString(string2)
     *   * string1 != string2 -> hashString(string1) != hashString(string2)
     *
     * @param {String} The string to be hashed.
     * @erturns {Number} The unique integer value for that string.
     */
    _pub.hashString = function hashString(text) {
        // The current implementation is optimized for speed. Any modifications
        // to it (such as using more modern features like for...of, reduce,
        // or Math.imul) can possibly slow it down.
        let hash = 0;
        for (let i = 0; i < text.length; i++) {
            let charCode = text.charCodeAt(i);
            // Equivalent to: (hash * 31) + charCode
            hash = ((hash << 5) - hash) + charCode;
            hash |= 0;
        }
        return hash;
    };

    /**
     * copy url to clipboard special handling for ipad|ipod|iphone
     */
    function iosCopyToClipboard() {
        const el = document.createElement('textarea');
        el.value = $location.absUrl();
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);

        // save current contentEditable/readOnly status
        const editable = el.contentEditable;
        const readOnly = el.readOnly;

        // convert to editable with readonly to stop iOS keyboard opening
        el.contentEditable = true;
        el.readOnly = true;

        // create a selectable range
        const range = document.createRange();
        range.selectNodeContents(el);

        // select the range
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        el.setSelectionRange(0, 999999);

        // restore contentEditable/readOnly to original state
        el.contentEditable = editable;
        el.readOnly = readOnly;

        document.execCommand('copy');
        document.body.removeChild(el);
    }

    /**
     * Function to copy current url to clipboard
     */
    _pub.copyURLToClipboard = () => {
        const isIe11 = navigator.userAgent.includes('Trident/');
        if (navigator.userAgent.match(/ipad|ipod|iphone/i) || isIe11) {
            iosCopyToClipboard();
        } else {
            navigator.clipboard.writeText($location.absUrl());
        }
    };

    /**
     * Creates a comparison function to be used in an array sort call, sorting an array to
     * match the sourceArray passed in. If the sourceArray is `["a", "c", "b"]`, an array
     * of matching elements should be sorted to match the same order. The keyExtractor function
     * will be called on the elements being sorted, and retrieves the key to use for sorting.
     * If sorting an array of objects, the keyExtractor can be used to reduce that object
     * to a simpler value to be sorted by (i.e. a single character to match the sourceArray).
     *
     * @param {Array} sourceArray - The array to use as the order to sort items. This should be
     *     a superset of the array to sort. If the array to be sorted has an item that is not
     *     included in the sourceArray, it will be located at the beginning of the array.
     * @param {Callback} keyExtractor - Called with an array object, should return a value
     *     that will be used for sorting. Values returned should match the values in the
     *     sourceArray.
     */
    _pub.sortBySource = function sortBySource(sourceArray, keyExtractor) {
        if (!keyExtractor) {
            keyExtractor = (x) => x;
        }
        return (left, right) => sourceArray.indexOf(keyExtractor(left)) - sourceArray.indexOf(keyExtractor(right));
    };

    return _pub;
}

module.exports = UtilService;
